module.exports = __webpack_public_path__ + "static/media/07.60928b87.jpg";